// components/RightSideModal.tsx
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import styled, { keyframes } from 'styled-components';
import 'animate.css';
import { Icon } from '@/presentation/components';
import { GoToButton } from '@/presentation/components/Schedule/components/CourseDetail';

export interface RightSideModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Overlay = styled.div.attrs({ 'data-testid': 'modal-overlay' })`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  animation: ${fadeIn} 0.3s ease;
  z-index: 1000;
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  max-width: 392px;
  width: 100%;
  background: #fff;
  border-radius: 0 8px 8px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1100;
`;

const Body = styled.div`
  padding: 16px;
  overflow-y: auto;
  flex: 0 0 auto;
`;

const DefaultButton = styled.button`
  width: 320px;
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  border-radius: 4px;
  padding-right: 24px;
  padding-left: 24px;
  background: #5b36f2;
  color: white;
  border: none;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

const Block = styled.div`
  color: var(--interaction-detail);
  align-items: start;
  cursor: pointer;
  height: 52px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 16px;
  border-bottom: 1px solid #7a959f;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 24px;
`;

export function RightSideModal({
  open,
  onClose,
  children
}: RightSideModalProps) {
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      <Overlay onClick={onClose} />
      <OutsideClickHandler onOutsideClick={onClose}>
        <Container className="animate__animated animate__slideInRight">
          <Block className="icon">
            <GoToButton padding="8px" buttonType="close" onClick={onClose}>
              <Icon name="x" size={28} />
            </GoToButton>
          </Block>
          <Body>{children}</Body>
          <Footer>
            <DefaultButton onClick={onClose}>Entendido</DefaultButton>
          </Footer>
        </Container>
      </OutsideClickHandler>
    </>,
    document.body
  );
}
